// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__eGMxV","footerInfo":"footer_footerInfo__4ax1X","company":"footer_company__JQHwW","footerInfoPadding":"footer_footerInfoPadding__xUFa0"};